<!-- eslint-disable max-len -->
<template>
  <div class="elm-center">
    <div class="g-p-10" />
  </div>
</template>

<script>
import Vue from 'vue';

import 'swiper/css/swiper.css';

export default Vue.extend({
  name: 'MobileStaticPage',
  components: {},
  created() {
    const downloadBar = document.querySelector('.download-app-bar');
    if (downloadBar) {
      downloadBar.style = 'display:none';
    }
  },
});
</script>

<style lang="scss" scoped>
.elm-center {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 100vh;
}
</style>
